import { ImmutableStore } from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';
import lunr from 'lunr';
import Immutable from 'immutable';

const defaultState = {
  id: '',
  key: '',
  name: 'Unknown',
  url: 'Unknown URL',
  address: {},
  contact: {},
  branches: [],
  showInactiveBranches: false,
  searchTerm: '',
  sidebarActive: true
};

class BankStore extends ImmutableStore {

  static storeName = 'BankStore';

  static handlers = {
    [Actions.UI__SIDEBAR_TOGGLED]:'handleSidebarToggle',
    [Actions.CLIENT_ACCOUNT__LOADED]: 'loadBankInfo',
    [Actions.CLIENT_ACCOUNT__ACCOUNT_UPDATED]: 'updateBankInfo',
    [Actions.CLIENT_ACCOUNT__ORG_UNIT_SEARCH_TERM_CHANGED]: 'updateBranchSearchTerm',
    [Actions.CLIENT_ACCOUNT__SHOW_INACTIVE_ORG_UNITS_TOGGLED]: 'setShowInactiveBranches',
    [Actions.CLIENT_ACCOUNT__ORG_UNIT_CREATED]: 'updateBranch',
    [Actions.CLIENT_ACCOUNT__ORG_UNIT_UPDATED]: 'updateBranch',
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
    this.setupIndex();
  }

  handleSidebarToggle() {
    this.mergeState({
      sidebarActive: !this.isSidebarActive()
    });
  }

  isSidebarActive() {
    return this.get('sidebarActive');
  }

  _extractBranches = (bankInfo) => {
    return bankInfo.branchHierarchy || [];  // Assumes branch hierarchy contains only branches.
  };

  loadBankInfo(bankInfo) {
    console.info('BankStore:loadBankInfo', bankInfo);
    const branches = this._extractBranches(bankInfo);
    this.mergeState({
      id: bankInfo.id,
      key: bankInfo.key,
      name: bankInfo.name,
      url: bankInfo.url,
      contact: bankInfo.contact,
      address: bankInfo.address,
      branches: branches
    });
    this.setupIndex(branches.slice());
  }

  updateBankInfo(bankInfo) {
    console.info('BankStore:updateBankInfo', bankInfo);
    this.mergeState({
      id: bankInfo.id,
      key: bankInfo.key,
      name: bankInfo.name,
      contact: bankInfo.contact,
      address: bankInfo.address,
      url: bankInfo.url
    });
  }

  getBankInfo() {
    return {
      id: this.get('id'),
      key: this.get('key'),
      name: this.get('name'),
      url: this.get('url'),
      contact: this.get('contact').toJS(),
      address: this.get('address').toJS()
    };
  }

  updateBranch(bank) {
    console.info('BankStore:updateBranch', bank);
    // TODO: Turn branches array into a map for lookup, maybe?
    const branches = this._extractBranches(bank);
    this.mergeState({
      branches: branches
    });
  }

  getBranches(query) {
    const searchTerm = query || this.get('searchTerm');
    const branches = this.get('branches');
    if (searchTerm) {
      const matched = this.branchIndex.search(searchTerm);
      const ids = Immutable.Set(matched.map(m => m.ref));
      const found = branches.filter(b => {
        return ids.contains(b.get('id'));
      });
      console.info('BankStore:getBranches, found', found);
      return found.toJS();
    } else {
      console.info('BankStore:getBranches, no search term specified');
      return branches.toJS();
    }
  }

  getAllBranches() {
    return this.get('branches').toJS();
  }

  getBranchById(branchId) {
    console.info('BankStore:getBranchById', branchId);
    const branch = this.getBranches().filter(b => b.id == branchId);
    return (branch.length) ? branch[0] : undefined;
  }

  updateBranchSearchTerm(search) {
    console.info('BankStore:updateBranchSearchTerm', search);
    this.mergeState({
      searchTerm: search
    });
  }

  setShowInactiveBranches(shouldShow) {
    console.info('BankStore:setShowInactiveBranches', shouldShow);
    this.mergeState({
      showInactiveBranches: shouldShow
    });
  }

  getShowInactiveBranches() {
    const shouldShow = this.get('showInactiveBranches');
    console.info('BankStore:getShowInactiveBranches', shouldShow);
    return shouldShow;
  }

  rehydrate(state) {
    const { branches = [] } = state;
    this.setupIndex(branches);
    super.rehydrate(state);
  }

  setupIndex = (branches = []) => {
    this.branchIndex = lunr(function () {
      this.field('name', { boost: 5 });
      this.field('street', { boost: 4 });
      this.field('city', { boost: 3 });
      this.field('state', { boost: 2 });
      this.field('zip', { boost: 1 });
      this.ref('id');
      branches.forEach(b => {
        const idxObject = {
          id: b.id,
          name: b.name,
          street: b.address.street,
          city: b.address.city,
          state: b.address.state,
          zip: b.address.zip
        };
        this.add(idxObject);
      });
    });
  };
}

export default BankStore;



// WEBPACK FOOTER //
// ./src/stores/BankStore.js